export const initArrayByLength = (length: number): number[] =>
    Array.from(Array(length).keys());
